import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateHeatingConfigurationRegulation',
})
export class TranslateHeatingConfigurationRegulationPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value) {
      value = value.charAt(0).toLowerCase() + value.slice(1);
      if (this.customTranslationsService.HEATING_CONFIGURATION_REGULATION[value]) {
        return this.translateService.instant(
          this.customTranslationsService.HEATING_CONFIGURATION_REGULATION[value]
        );
      }
    }

    return value;
  }
}
